import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/familyMotion/banner.jpg'
import navBg from '../../assets/familyMotion/nav/nav_bg.png'

import far1 from '../../assets/familyMotion/nav/far1.png'
import far1_active from '../../assets/familyMotion/nav/far1_active.png'
import far2 from '../../assets/familyMotion/nav/far2.png'
import far2_active from '../../assets/familyMotion/nav/far2_active.png'
import far3 from '../../assets/familyMotion/nav/far3.png'
import far3_active from '../../assets/familyMotion/nav/far3_active.png'
import far4 from '../../assets/familyMotion/nav/far4.png'
import far4_active from '../../assets/familyMotion/nav/far4_active.png'
import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(124.6),
    backgroundColor: '#D8D9DB',
    boxSizing: 'border-box'
  },
  navCtn: {
    paddingLeft: calcRemFn(12),
    paddingRight: calcRemFn(12),
    height: calcRemFn(124.5),
    width: calcRemFn(375),
    boxSizing: 'border-box',
    backgroundImage: `url(${navBg})`
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  topBtnBaseCss: {
    width: calcRemFn(61),
    height: calcRemFn(72.5),
    margin: '0 auto',
    marginTop: calcRemFn(30)
  },

}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    },
    {
      key: 'top4',
      show: true,
      img: far4,
      img_actived: far4_active,
    }
  ]
}
const pictureList = [
  {
    key: '1_1',
    picNum: 2,
    pid: 106018
  },
  {
    key: '1_2',
    picNum: 1,
    pid: 106018
  },
  {
    key: '1_3',
    picNum: 1,
    pid: 106018
  },
  {
    key: '1_4',
    picNum: 2,
    pid: 106018
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach((item,index) => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/familyMotion/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[1]}_i${indexArr[0]}`,
      farName: `top${indexArr[1]}`,
      sonName: `_i${indexArr[0]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)
// pictures.unshift({
//   son: [
//     require('../../assets/familyMotion/ctn/1_0_1.jpg')
//   ],
// })


const topDiff = {
  firstSon: '_i1'
}

export default {
  title: '运动健将',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
